// extracted by mini-css-extract-plugin
export default {"container":"MatterDetails_container__ZxfS8","error":"MatterDetails_error__1QFeT","matter-details-container":"MatterDetails_matter-details-container__imSFe"};